import { useQuery } from '@tanstack/react-query';
import { seoApi } from '@/api/seo';
import { queryKeys } from '@/lib/queryKeys';
import { useApiMutation, type MutationCallbacks } from '@/hooks/useApiMutation';

export function useSeoNetwork() {
  return useQuery({ queryKey: queryKeys.seo.network, queryFn: seoApi.network });
}

/** One site's SEO; asked again every half minute while a look it asked for is on its way. */
export function useSiteSeo(siteId: string) {
  return useQuery({
    queryKey: queryKeys.seo.site(siteId),
    queryFn: () => seoApi.site(siteId),
    refetchInterval: (query) => (query.state.data?.requested ? 30_000 : false),
  });
}

export function useRequestSeoCheck(siteId: string, callbacks?: MutationCallbacks<{ requested: boolean }, void>) {
  return useApiMutation(() => seoApi.requestCheck(siteId), () => [queryKeys.seo.site(siteId)], callbacks);
}

export function useAddKeyPage(siteId: string, callbacks?: MutationCallbacks<{ id: string; path: string }, string>) {
  return useApiMutation((path: string) => seoApi.addKeyPage(siteId, path), () => [queryKeys.seo.site(siteId)], callbacks);
}

export function useRemoveKeyPage(siteId: string, callbacks?: MutationCallbacks<{ removed: boolean }, string>) {
  return useApiMutation((pageId: string) => seoApi.removeKeyPage(siteId, pageId), () => [queryKeys.seo.site(siteId)], callbacks);
}
